module.exports = __webpack_public_path__ + "media/images/crafts/crafts-7d4ec437739d52b58e5343a004f79d98.jpg";